<template>
  <ion-item @click="getPatientData(id)">
    <ion-avatar slot="start">
      <img src="./avatar-leia.png">
    </ion-avatar>
    <ion-label>
      <h2>{{name}}</h2>
    </ion-label>
    <ion-reorder slot="end"></ion-reorder>
  </ion-item>
</template>

<script>
  import { db, firebase, storage } from '@/firebase/firebase';

  export default {
    name: 'profileListItem',
    props: ['name', 'id'],
    components: {},
    data() {
      return {};
    },
    methods: {
      getPatientData(id) {
        db.collection('users')
          .doc(id)
          .get()
          .then(function (doc) {
            if (doc.exists) {
              console.log('Document data:', doc.data());
            } else {
              // doc.data() will be undefined in this case
              console.log('No such document!');
            }
          })
          .catch(function (error) {
            console.log('Error getting document:', error);
          });
      }
    },
    created() {
    },
  };
</script>
